
import { createSlice } from "@reduxjs/toolkit";
import { IStudentEarlyAlertsSlice } from "../../../models/student/studentGrades";
import { IWorkloadSlice } from "../../../models/faculty/facultyWorkload";

const initialWorkloadState: IWorkloadSlice = {
    workload: undefined,
  };
  
  const workloadSlice = createSlice({
    name: "workload",
    initialState: initialWorkloadState,
    reducers: {
      setWorkload: (state, action: { payload: any }) => {
        state.workload = action.payload;
      },
    },
  });
  
  export const { setWorkload } = workloadSlice.actions;
  
  const workloadReducer = workloadSlice.reducer;
  
  export type workloadState = ReturnType<typeof workloadReducer>;
  
  export default workloadReducer;